import React from 'react'
import DiscountRuleRow from "./discount-rule-row";

export default function DiscountRules({ rules }) {
  return (
    <table className="min-w-full divide-y divide-gray-300">
      <thead className="bg-gray-50">
        <tr>
          <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
            Source
          </th>
          <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
            Discount Strategy
          </th>
          <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
            Cost Plus
          </th>
          <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
            Retail Minus
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 bg-white">
        { rules.map((rule, index) => <DiscountRuleRow rule={rule} key={`rule-${rule.id}-${index}`} /> )}
      </tbody>
    </table>
  )
}
